// src/pages/Terms.jsx
import { useIntl } from "react-intl";
import LanguageSelector from "../components/LanguageSelector";
import { useLocation } from "react-router-dom";

export default function Terms() {
  const intl = useIntl();
  const { search } = useLocation();

  return (
      <div className="fullscreen-layout">
        <div className="left-panel">
          <div className="hero-panel">
            <img src="/lugarlogopw.png" alt="LugarAI Logo" />
            <h2>{intl.formatMessage({ id: "termsTitle" })}</h2>
            <p>{intl.formatMessage({ id: "termsIntro" })}</p>
          </div>
        </div>

        <div className="right-panel">
          <div style={{ position: "absolute", top: 20, right: 20 }}>
            <LanguageSelector />
          </div>

          <div className="auth-form">
            <p>{intl.formatMessage({ id: "termsContent" })}</p>
          </div>
        </div>
      </div>
  );
}
